export const UserLoader = () => {
  return (
    <div className="grid w-screen h-screen place-items-center bg-grey-300 dark:bg-blue-1100">
      <div className="w-20 h-20 border-8 border-grey-400 dark:border-grey-700 rounded-full animate-spin border-t-blue-700 dark:border-t-blue-400" />
    </div>
  );
};
